export default {
  optional: 'Optional',
  radioCheckbox: 'Please answer the question',
  agreeField: 'Please read and accept the notice',
  birthDate: {
    max: 'The age entered is above the maximum allowed.',
    min: 'The age entered is below the minimum required.',
  },
};
